import { useRef } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import styled from "styled-components";
import Hero from "./sections/Hero";
import MovingText from "./sections/MovingText";
import About from "./sections/About";
import Services from "./sections/Services";
import Achievements from "./sections/Achievements";
import Packages from "./sections/Packages";
import Why from "./sections/Why";
import CaseStudies from "./sections/CaseStudies";
import Contact from "./sections/Contact";
import Testimonials from "./sections/Testimonials";

const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main``;

const Layout = () => {
  const aboutRef = useRef<HTMLDivElement>(null);
  const servicesRef = useRef<HTMLDivElement>(null);
  const achievementsRef = useRef<HTMLDivElement>(null);
  const packagesRef = useRef<HTMLDivElement>(null);
  const caseStudiesRef = useRef<HTMLDivElement>(null);
  const contactRef = useRef<HTMLDivElement>(null);

  return (
    <LayoutContainer>
      <Navigation
        aboutRef={aboutRef}
        servicesRef={servicesRef}
        achievementsRef={achievementsRef}
        packagesRef={packagesRef}
        caseStudiesRef={caseStudiesRef}
        contactRef={contactRef}
      />
      <Main>
        <div className="bg-[#F9FAFB] w-full">
          <Hero />
        </div>
        <MovingText />
        <div className="bg-[#0E0E0E] w-full" ref={aboutRef}>
          <About />
        </div>
        <div ref={servicesRef}>
          <Services />
        </div>
        <div className="bg-[#F9FAFB] w-full" ref={achievementsRef}>
          <Achievements />
        </div>
        <div ref={packagesRef}>
          <Packages />
        </div>
        <div className="bg-[#e6f1ff] w-full">
          <Why />
        </div>
        <div className="bg-[#F9FAFB] w-full" ref={caseStudiesRef}>
          <CaseStudies />
        </div>
        <MovingText />
        <div className="bg-[#F9FAFB] w-full">
          <Testimonials />
        </div>
        <div ref={contactRef}>
          <Contact />
        </div>
        <div className="w-full bg-[#F9FAFB]">
          <Footer
            aboutRef={aboutRef}
            servicesRef={servicesRef}
            achievementsRef={achievementsRef}
            packagesRef={packagesRef}
            caseStudiesRef={caseStudiesRef}
            contactRef={contactRef}
          />
        </div>
      </Main>
    </LayoutContainer>
  );
};

export default Layout;
